import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        display: 'flex',
        padding: theme.spacing(2),
        flexDirection: 'column',
    },
    grid: {
        height: '100%',
    }
}))